import { DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import AButton from "../../../common/form-fields-mui/AButton";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";

export const timepickerStyle = {
  "& .MuiInputBase-input": {
    height: "20px",
    padding: "10px",
  },
  "& .MuiInputAdornment-root": {
    display: "none",
  },
};

const TimeSelectionForm = ({
  index,
  testUpdateHandler,
  testData,
  minTime = new moment(),
  maxTime = new moment(),
  closeForm,
  isTimeTableEvent = false,
  field = "",
}) => {
  const [startTime, setStartTime] = useState(
    field === "onlineTestDate"
      ? testData["onlineTestStartTime"]
      : testData["testStartTime"]
  );
  const [endTime, setEndTime] = useState(
    field === "onlineTestDate"
      ? testData["onlineTestEndTime"]
      : testData["testEndTime"]
  );

  const handleSave = () => {
    if (!moment(startTime).isValid() || !moment(endTime).isValid()) {
      failureToast("Please enter valid time");
      return;
    } else if (
      !moment(startTime).isSameOrAfter(moment(minTime)) ||
      !moment(endTime).isSameOrBefore(moment(maxTime))
    ) {
      failureToast("Please enter time within permissible window");
      return;
    } else if (moment(startTime)?.isSameOrAfter(moment(endTime))) {
      failureToast("Start time should be less than end time");
      return;
    } else if (
      !isTimeTableEvent &&
      field &&
      moment(endTime).diff(moment(startTime), "hours") < 3
    ) {
      failureToast(
        "End time should be at least 3 hours apart from the start time."
      );
      return;
    } else if (
      !isTimeTableEvent &&
      field &&
      testData.isStartWithinTimeRequired &&
      moment(endTime).diff(moment(startTime), "hours") <
        testData.startWithinTimePeriod
    ) {
      failureToast(
        "Test duration cannot be shorter than the 'Start Within' time. Please ensure the time slot is equal to or greater than the Start Within value."
      );
      return;
    } else {
      testUpdateHandler(
        index,
        startTime,
        field === "onlineTestDate" ? "onlineTestStartTime" : "testStartTime"
      );
      testUpdateHandler(
        index,
        endTime,
        field === "onlineTestDate" ? "onlineTestEndTime" : "testEndTime"
      );
      closeForm();
    }
  };

  return (
    <Card style={{ marginBottom: 0 }}>
      <CardBody>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <div className="d-flex flex-column">
            <div>
              <div
                className="mb-1"
                style={{
                  fontSize: "14px",
                  color: "#757575",
                  fontWeight: 400,
                  lineHeight: "16px",
                }}
              >
                Select start time (24-hour)
              </div>
              <div>
                <DesktopTimePicker
                  ampm={false}
                  disableIgnoringDatePartForTimeValidation
                  minTime={minTime ? moment(minTime) : ""}
                  value={moment(startTime)}
                  // onChange={(value) => testUpdateHandler(index, value, "testStartTime")}
                  onChange={(value) => {
                    const selectedStartTime = moment(
                      field === "onlineTestDate"
                        ? testData?.onlineTestDate
                        : testData?.testDate
                    )
                      .set("hour", moment(value).hour())
                      .set("minute", moment(value).minute());
                    setStartTime(selectedStartTime);
                  }}
                  sx={timepickerStyle}
                />
              </div>
            </div>
            <div className="mt-3">
              <div
                className="mb-1"
                style={{
                  fontSize: "14px",
                  color: "#757575",
                  fontWeight: 400,
                  lineHeight: "16px",
                }}
              >
                Select end time
              </div>
              <div>
                <DesktopTimePicker
                  ampm={false}
                  value={moment(endTime)}
                  onChange={(value) => {
                    const selectedEndTime = moment(
                      field ? testData.onlineTestEndDate : testData.testDate
                    )
                      .set("hour", moment(value).hour())
                      .set("minute", moment(value).minute());
                    setEndTime(selectedEndTime);
                  }}
                  sx={timepickerStyle}
                  disableIgnoringDatePartForTimeValidation
                  minTime={moment(startTime)}
                  maxTime={maxTime ? moment(maxTime) : ""}
                />
              </div>
            </div>
            <div className="mt-3">
              <AButton
                className="btn-left-0"
                variant="primary_filled"
                updatedStyle={{ height: "40px", width: "100%" }}
                onClick={handleSave}
              >
                Save
              </AButton>
            </div>
          </div>
        </LocalizationProvider>
      </CardBody>
    </Card>
  );
};

export default TimeSelectionForm;
